export default "__VITE_ASSET__c6d0d0b9__"